/**
 * 全局变量、系统配置。注册到vue里
 */

export default {
 
}
